import { Skeleton } from "../../shadcn/skeleton";

const ProductDetailSkeleton = () => {
  return (
    <div className="py-4">
      <div className="container-minify">
        {/* Breadcrumb Skeleton */}
        <div className="flex items-center gap-2 mb-4">
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-4 w-4" />
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-4 w-4" />
          <Skeleton className="h-4 w-28" />
        </div>

        <div className="flex flex-col lg:flex-row gap-4 lg:gap-6 xl:gap-8">
          {/* Image Slider Skeleton */}
          <div className="w-full lg:w-2/5 xl:w-1/2 2xl:w-2/5 lg:sticky lg:top-4 lg:self-start shrink-0">
            <div className="space-y-3 flex flex-col">
              {/* Ana görsel + desktop thumbnails */}
              <div className="flex gap-3 relative h-[calc(100dvh-280px)] md:h-[calc(100dvh-200px)] min-h-64">
                {/* Desktop thumbnail sidebar */}
                <div className="hidden md:flex w-16 lg:w-20 shrink-0 flex-col gap-2 p-1">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <Skeleton key={i} className="aspect-3/4 rounded-md" />
                  ))}
                </div>
                {/* Main Image */}
                <Skeleton className="flex-1 rounded-xl" />
              </div>
              {/* Mobil yatay thumbnail swiper */}
              <div className="md:hidden flex gap-2 px-1">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Skeleton key={i} className="aspect-3/4 rounded-md w-[22%] shrink-0" />
                ))}
              </div>
              {/* Model Info */}
              <Skeleton className="h-12 rounded-lg shrink-0" />
            </div>
          </div>

          {/* Product Information Skeleton */}
          <div className="flex-1 min-w-0 lg:w-2/5 xl:w-1/3 2xl:w-2/5">
            <div className="space-y-4">
            {/* Title */}
            <div className="space-y-2">
              <Skeleton className="h-6 w-3/4" />
              <Skeleton className="h-6 w-full" />
            </div>

            {/* Rating */}
            <div className="flex items-center gap-2">
              <Skeleton className="h-4 w-12" />
              <Skeleton className="h-4 w-24" />
              <Skeleton className="h-4 w-32" />
            </div>

            {/* Badges */}
            <Skeleton className="h-8 w-2/3 rounded-2xl" />

            {/* Social Proof */}
            <Skeleton className="h-6 w-1/2" />

            {/* Price */}
            <div className="space-y-2 pt-2 pb-4 border-b">
              <Skeleton className="h-4 w-32" />
              <Skeleton className="h-10 w-48" />
            </div>

            {/* Colors */}
            <div className="space-y-3">
              <Skeleton className="h-4 w-24" />
              <div className="grid grid-cols-8 gap-2">
                {Array.from({ length: 8 }).map((_, i) => (
                  <Skeleton key={i} className="aspect-48/72" />
                ))}
              </div>
            </div>

            {/* Sizes */}
            <div className="space-y-3">
              <Skeleton className="h-4 w-20" />
              <div className="grid grid-cols-8 gap-2">
                {Array.from({ length: 8 }).map((_, i) => (
                  <Skeleton key={i} className="h-9 rounded-lg" />
                ))}
              </div>
            </div>

            {/* Buttons */}
            <div className="flex gap-3">
              <Skeleton className="h-12 flex-1" />
              <Skeleton className="h-12 flex-1" />
              <Skeleton className="h-12 w-12 rounded-full" />
            </div>

            {/* Delivery Info */}
            <Skeleton className="h-24 rounded-xl" />

            {/* Features */}
            <div className="space-y-3">
              <Skeleton className="h-4 w-40" />
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
                {Array.from({ length: 4 }).map((_, i) => (
                  <Skeleton key={i} className="h-16" />
                ))}
              </div>
            </div>
            </div>
          </div>

        {/* Sidebar Skeleton */}
        <div className="w-full lg:w-1/5 xl:w-1/7 2xl:w-1/6 hidden lg:block shrink-0">
          <div className="space-y-4">
            <Skeleton className="h-12 rounded-md" />
            <Skeleton className="h-32 rounded-md" />
            <Skeleton className="h-24 rounded-md" />
          </div>
        </div>
        </div>

      {/* Footer Sections Skeleton */}
      <div className="space-y-6 md:space-y-8 lg:space-y-10 my-6 md:my-8 lg:my-10">
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={i} className="space-y-4">
            <Skeleton className="h-6 w-48" />
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              {Array.from({ length: 4 }).map((_, j) => (
                <Skeleton key={j} className="aspect-3/4 rounded-lg" />
              ))}
            </div>
          </div>
        ))}
      </div>
      </div>
    </div>
  );
};

export default ProductDetailSkeleton;
